import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";

import React, { useMemo, useEffect, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { useHistory } from "react-router-dom";
import AuthService from "services/auth.services.js";
import ApiService from "services/api.js";
import UtilService from "services/util.service.js";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import Pagination from "components/dataDispaly/Pagination";
import HeaderHistoryData from "./HeaderHistoryData";

// Assets
import { MdCheckCircle, MdCancel, MdOutlineError } from "react-icons/md";
export default function HistoryData(props) {
  // custom variable

  let DateFrom = UtilService.dateFrom;
  let DateTo = UtilService.dateTo;

  const history = useHistory();

  // Use state variable
  const { columnsData } = props;
  const [data, setData] = useState([]);
  const [dataPage, setDataPage] = useState([]);
  const [dataPageSize, setDataPageSize] = useState(5);
  const [loading, setLoading] = useState(true);
  const [inputDateFrom, setDateFrom] = useState(DateFrom);
  const [inputDateTo, setDateTo] = useState(DateTo);
  const [inputBranch, setInputBranch] = useState("");
  const [inputBillStatus, setBillStatus] = useState("");

  // ref variable
  const skipPageResetRef = React.useRef();
  // memo variable
  const columns = useMemo(() => columnsData, [columnsData]);

  let getToken = JSON.parse(localStorage.getItem("user"));
const options = {
    headers: {
      Authorization: "Bearer " + getToken.token,
    },
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageCount: dataPage },
      manualPagination: true,
      pageCount: dataPage,
      autoResetPage: !skipPageResetRef.current,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setLoading(true);
    try {
      const fetchData = async () => {
        try {
          skipPageResetRef.current = true;
          let response = await ApiService.client.get(
            `/historyPush/getAllHistoryPushWithFilterAndPagination/${
              pageIndex + 1
            }/${dataPageSize}/${inputBranch === "" ? "All" : inputBranch}/All/${
              inputBillStatus === "" ? "All" : inputBillStatus
            }/${inputDateFrom}/${inputDateTo}`,
            await ApiService.options()
          );
          // console.log("total_halaman", response.data["total_halaman"]);
          setDataPage(response.data["total_halaman"]);
          setPageSize(dataPageSize);
          setData(response.data.data);
          skipPageResetRef.current = false;
        } catch (error) {
          if (error.response.status === 401) {
            // AuthService.logout().then(
            //   () => {
           //     console.log("Success Logout");
            //   },
            //   (error) => {
            //     (error.response &&
            //       error.response.data &&
            //       error.response.data.message) ||
            //       error.message ||
            //       error.toString();
            //   }
            // );
            // history.push("/auth/sign-in");
          }

          // console.log("error ni", error.response.status);
        }
      };
      fetchData();
    } catch (error) {
      if (error.response.status === 401) {
        history.push("/auth/sign-in");
      }
      // console.log(error);
    }
  }, [
    pageIndex,
    dataPage,
    dataPageSize,
    pageSize,
    inputBranch,
    inputBillStatus,
    inputDateFrom,
    inputDateTo,
  ]);

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  // console.log("ini data lho", data);

  return (
    <Card
      direction={{ base: "column", sm: "row" }}
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", md: "scroll", lg: "scroll" }}
    >
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          History Data
        </Text>
        <Menu />
      </Flex>

      <HeaderHistoryData
        inputDateFrom={inputDateFrom}
        inputDateTo={inputDateTo}
        inputBillStatus={inputBillStatus}
        inputBranch={inputBranch}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        setBillStatus={setBillStatus}
        setInputBranch={setInputBranch}
      />

      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe="10px"
                  key={index}
                  borderColor={borderColor}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                {row.cells.map((cell, index) => {
                  let data = "";
                  if (cell.column.Header === "DATE") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "BRANCH ID") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "BILL ID") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "BILL STATUS") {
                    data = (
                      <Flex align="center">
                        <Icon
                          w="24px"
                          h="24px"
                          me="5px"
                          color={
                            cell.value === "OK"
                              ? "green.500"
                              : cell.value === "Cancel"
                              ? "red.500"
                              : cell.value === "Error"
                              ? "orange.500"
                              : null
                          }
                          as={
                            cell.value === "OK"
                              ? MdCheckCircle
                              : cell.value === "Cancel"
                              ? MdCancel
                              : cell.value === "Error"
                              ? MdOutlineError
                              : null
                          }
                        />
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      </Flex>
                    );
                  }
                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent"
                    >
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>

      <Pagination
        canNextPage={canNextPage}
        nextPage={nextPage}
        canPreviousPage={canPreviousPage}
        previousPage={previousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        gotoPage={gotoPage}
        pageSize={pageSize}
        setDataPageSize={setDataPageSize}
        pageCount={pageCount}
      />
    </Card>
  );
}
